import { render, staticRenderFns } from "./HabilityAddEdit.vue?vue&type=template&id=cb48ef2a"
import script from "./HabilityAddEdit.vue?vue&type=script&lang=js"
export * from "./HabilityAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports